




























































import Vue from "vue";

export default Vue.extend({
  name: "FinishForm",

  data() {
    return {
      passedZero: false,
      zeroStatus: 0,
      zeroComment: "",
      loading: false,
      zeroCommentRules: [
        (v) => v.length < 1000 || this.$t("zero_comment.length_error")
      ]
    };
  },

  methods: {
    async saveZeroStatus() {
      this.loading = true;
      await this.$store.dispatch("general/saveZeroStatus", {
        zeroStatus: this.zeroStatus,
        zeroComment: this.zeroComment
      });
    }
  }
});
